import { render, staticRenderFns } from "./arah_kebijakan_tahunan.vue?vue&type=template&id=1e14f79e&"
import script from "./arah_kebijakan_tahunan.vue?vue&type=script&lang=js&"
export * from "./arah_kebijakan_tahunan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports